// src/pages/VerifyEmail.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/auth/verify/${token}`
        );

        if (res.status === 200) {
          setStatus("success");
          setTimeout(() => navigate("/login"), 3000); // redirect to login after 3s
        } else {
          setStatus("error");
        }
      } catch (err) {
        console.error("Verification error:", err);
        setStatus("error");
      }
    };

    verify();
  }, [token, navigate]);

  if (status === "loading") return <p>Verifying your email...</p>;
  if (status === "success")
    return <p>✅ Email verified! Redirecting you to login...</p>;
  return <p>❌ Verification failed. Try requesting a new link.</p>;
};

export default VerifyEmail;